export type Position = {
  event_title: string;
  outcome_title: string;
  id: number;
  event_id: number;
  outcome_side?: string;
  total_quantity?: number;
  total_matched_quantity?: number;
  average_price?: number | null;
  bet_count?: number;
};

export enum EVETSTATUS {
  POSTED = "posted",
  MODERATION = "moderation",
}

export type Event = {
  event: string;
  status: EVETSTATUS;
};

export type Referal = {
  tokens: number;
  ref_user: {
    username: string;
    date_joined: string;
  };
};

export type Notification = {
  created: string;
  id: string;
  is_read: boolean;
  object_id?: number;
  object_link?: string;
  object_type?: string;
  text: string;
  title: string;
  notification_image?: string;
  long_title: null | string;
  long_text: null | string;
  is_plus: boolean;
};

export type Profile = {
  password: string;
  description: string;
  nikname: string;
  email: string;
  phone: string;
};

export type SignInPayload = {
  email: string;
  password: string;
};

export type VerifyCodePayload = {
  email: string;
  code: string;
};

export type SignUpPayload = {
  email: string;
  password: string;
};

export type User = {
  id: string;
  username: string;
  email: string;
  phone_number: string;
  profile_picture: string;
  is_verified: boolean;
  description: string;
  balance: {
    available: number;
    reserved: number;
  };
};

export enum RESPONSSTAUTS {
  SUCCESS_CREATE = 201,
  SUCCESS = 200,
  FAILD = 400,
  SUCCESS_NO_CONTENT = 204,
}

export type EditUserPayload = {
  username?: string;
  email: string;
  phone_number?: string;
  is_verified?: boolean;
  profile_picture?: File;
  balance?: string;
  description?: string;
};

export type MardAsReadPayload = {
  notification_ids: string[];
};

export type TelegramAuthPayload = {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
};

export type Outcome = {
  label: string;
  is_win: boolean;
};

export enum EVENTSIDE {
  BUY = "buy",
  SELL = "sell",
}

export type OutComesData = {
  event: number;
  event_title: string;
  id: number;
  is_win: boolean;
  label: string;
  side: EVENTSIDE;
};

export type BetVolume = {
  outcome_id: number;
  outcome_label: string;
  outcome_side: string;
  volume: string;
};

export type EventData = {
  author: string;
  author_username: string;
  created_at: string;
  deadline: string;
  description: string;
  event_image: null | string;
  id: number;
  is_confirm: boolean;
  title: string;
  outcomes_data: OutComesData[];
  is_favorite?: boolean;
  volume: number;
  price: Record<number, number>;
  max_volume: number;
  individual_commission: string;
  stop_deadline: null | string;
  is_active: boolean;
};

export type UserEvent = {
  id: number;
  is_confirm: boolean;
  title: string;
};

export type GetEventPayload = {
  page: number;
  size: number;
  filter?: number;
  search: string;
};

export type PaginationData = {
  page: number;
  size: number;
};

export type ApplyPromoCodePayload = {
  code: string;
};

export enum SIDE {
  BUY = "buy",
  SELL = "sell",
}

export enum HISTORYSTATUS {
  OPEN = "open",
  MATCHED = "matched",
  CANCELLED = "cancelled",
  SETTELED = "settled",
}

export type History = {
  id: number;
  event_id: number;
  event_title: string;
  user_outcome_title: string;
  winning_outcome_title: string;
  profit_loss: string | number;
  is_win: boolean | null;
  quantity: number;
  bet_count?: number;
  status: HISTORYSTATUS;
  created: string;
  settled_at: string;
};

export type FilterEvent = {
  id: number;
  title: string;
};

export type CreateBetPayload = {
  outcome: number;
  quantity: number;
  expected_price?: number;
};

export type ChartData = {
  ask_outcome_price: string;
  bid_outcome_price: string;
  created: string;
  event: number;
  id: number;
};

export type ForgetPasswordPayload = {
  email: string;
};

export type SendResetCodePayload = {
  email: string;
  code: string;
};

export type ResetPasswordPayload = {
  email: string;
  new_password: string;
};
